import { useCallback, useEffect, useState } from 'react';

type ReturnHook = {
  loading: boolean;
  isCompatible: boolean;
};

export default function useApplePayCompatibility(): ReturnHook {
  const [loading, setLoading] = useState(true);
  const [isLoad, setIsLoad] = useState(false);
  const [isCompatible, setIsCompatible] = useState(false);
  const onScriptLoad = useCallback(() => setIsLoad(true), []);

  useEffect(() => {
    let script = document.getElementById(
      'sdpx-verify-applepay'
    ) as HTMLScriptElement;

    if (!script) {
      script = document.createElement('script');
      script.src =
        'https://resources.sips-services.com/rsc/applepay/js/device_verification.js';
      script.id = 'sdpx-verify-applepay';

      document.body.append(script);

      script.addEventListener('load', onScriptLoad);
    } else if (window['sdpx'] !== undefined) {
      setIsLoad(true);
    } else {
      script.addEventListener('load', onScriptLoad);
    }

    return () => {
      script.removeEventListener('load', onScriptLoad);
    };
  }, []);

  useEffect(() => {
    if (!window['sdpx']) {
      setLoading(false);
      console.error(
        'We cannot load the script to check if the device is compatible.'
      );

      return;
    }

    window['sdpx'].isApplePayAvailable().then(({ responseCode, reason }) => {
      setLoading(false);

      if (responseCode === '00') {
        setIsCompatible(true);
      } else if (responseCode === '99') {
        console.error(reason);
      }
    });
  }, [isLoad]);

  return {
    loading,
    isCompatible,
  };
}
